module.exports = __webpack_public_path__ + "img/in-out.e5bd44bb.svg";